//系统参数
export const SYS = 'sys/' // 注销方法
export const LOGOUT = 'logout' // 注销方法
export const LOGIN = 'login' // 登录
export const PUT_TOKEN = 'putToken' // 设置tocken的值
export const CLEAR_TOKEN = 'clearToken' // 清空tocken
export const PUT_USER = 'putUser' // 设置user的值
export const CLEAR_USER = 'clearUser' // 清空user

//业务参数
export const BUSI = 'busi/' //
export const REC_TYPE = 'recType/' //
export const BAO_RECORDS = 'baoRecords' //宝记数据
export const BAO_RECORDS_TYPE = 'baoRecordsType' //宝记数据
